import { render } from "./Invoice.vue?vue&type=template&id=7356ed7c&scoped=true&ts=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=7356ed7c&scoped=true&lang=css"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7356ed7c"]])

export default __exports__